export const SIZE_CURVE_IMPORT = {
    IMPORT_MESSAGE: "import-message",
};
